import { Fragment, type FunctionComponent } from "react";

type ProgressBarProps = {
  currentStep: number;
  steps: number;
};
export const ProgressBar: FunctionComponent<ProgressBarProps> = (props: ProgressBarProps) => {
  let width = {
    width: `${(props.currentStep / props.steps) * 100}%`,
  };

  return (
    <Fragment>
      <div className="text-right text-sm text-neutral-500 mb-2">
        {props.currentStep}/{props.steps} abgeschlossen
      </div>
      <div className="rounded-lg bg-neutral-100 h-4 mb-10">
        <div className="h-4 bg-success rounded-lg" style={width}></div>
      </div>
    </Fragment>
  );
};
